export default{
    logo:'',
    navBars:{
                    active:'0',
                    list:[                  
                    {
                        name:'메인',
                        subActive:'0',
                        submenu:[

                          
                            {
                           
                            name:'회원관리',
                            type:'evo',
                            level:2,
                            pathname:'memlist_list',
                             children: [

                                  {
                            icon:'el-icon-s-data',
                            name:'일일 현황판',
                            type:'evo',
                            level:2,
                            pathname:'dashboard_index'
                        },
                        {
                                
                                icon:'el-icon-user',
                                name:'회원목록',
                                pathname:'memlist_list'

                            }

                            ,{
                                
                                icon:'el-icon-s-custom',
                                name:'파트너목록',
                                pathname:'management_list'

                            }
                            , {
                            icon:'el-icon-coin',
                            name:'회원 입/출금',
                            pathname:'money_list'
                        }, {
                            icon:'el-icon-money',
                            name:'충전신청',
                            pathname:'layModel1'
                        }, {
                            icon:'el-icon-money',
                            name:'출금신청',
                            pathname:'layModel2'
                        }]
                            
                        },
                          {
                           
                            name:'정산관리',
                            type:'evo',
                            level:2,
                            pathname:'calcuser_list',
                             children: [{
                                
                                icon:'el-icon-date',
                                name:'단계별 정산',
                                pathname:'calcuser_list'

                            }, 
                            {
                             icon:'el-icon-bangzhu',
                            name:'통합정산',
                            pathname:'calculation_new_list'
                            }, 
                        {
                            icon:'el-icon-notebook-2',
                            name:'나의 머니 변동내역',
                            pathname:'moneylogs_user_list'
                        }]
                            
                        },
                       {
                            
                            name:'베팅내역',
                            type:'evo',
                            level:2,
                            pathname:'betting_list1',
                             children: [{
                                icon:'el-icon-star-off',
                                name:'배팅내역',
                                pathname:'betting_list1',

                            }]
                            
                        },{
                           
                            name:'관리자 문의',
                            type:'evo',
                            level:2,
                            pathname:'qa_list',
                             children: [{
                                
                                icon:'el-icon-chat-dot-square',
                                name:'문의하기',
                                pathname:'qa_list'

                            }, {
                             icon:'el-icon-collection-tag',
                            name:'쪽지수신함',
                            pathname:'memo_list'
                        }]
                            
                        }]
                    }]

                }
                
                
            
}


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 